/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  block: Boolean,
  content: {
    type: [String, Function]
  },
  "default": {
    type: [String, Function]
  },
  disabled: Boolean,
  href: String,
  ghost: Boolean,
  icon: {
    type: Function
  },
  loading: Boolean,
  shape: {
    type: String,
    "default": "rectangle",
    validator: function validator(val) {
      return ["rectangle", "square", "round", "circle"].includes(val);
    }
  },
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      return ["small", "medium", "large"].includes(val);
    }
  },
  tag: {
    type: String,
    "default": void 0,
    validator: function validator(val) {
      return ["button", "a", "div"].includes(val);
    }
  },
  theme: {
    type: String,
    "default": void 0,
    validator: function validator(val) {
      return ["default", "primary", "danger", "warning", "success"].includes(val);
    }
  },
  type: {
    type: String,
    "default": "button",
    validator: function validator(val) {
      return ["submit", "reset", "button"].includes(val);
    }
  },
  variant: {
    type: String,
    "default": "base",
    validator: function validator(val) {
      return ["base", "outline", "dashed", "text"].includes(val);
    }
  },
  onClick: Function
};

export { props as default };
//# sourceMappingURL=props.js.map
